

var jbevents2 = {
    "type": "FeatureCollection",
    "features": [
 
           {
  "type": "Feature",
  "properties": {
    "week_num": 2,
    "season": "Winter 25'",
    "date": "2025-02-15",
    "name": "Four Seasons Resort Dubai at Jumeirah Beach",
    "address": "Dubai, United Arab Emirates",
    "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/dubai_rating.png?v=1743130878",
    "city": "Dubai",
    "country": "United Arab Emirates",
    "category": "Resort Escapes",
    "sub-category": "Waterfront Retreats",
    "month": "February",
    "collection_name": "World Tour",
    "highlight": "Beachfront Luxury & Pet-Friendly Paradise",
    "experience_description": "Indulge in sumptuous beachfront living with world-class service and exquisite pet-friendly amenities at the Four Seasons Resort Dubai at Jumeirah Beach.",
    "caption": "Beachfront Luxury & Pet-Friendly Paradise",
    "morning": "Begin your day with a gourmet breakfast and a refreshing beach walk in Dubai.",
    "midday": "Relax by the pool or enjoy a pampering spa session.",
    "afternoon": "Explore the vibrant city or unwind at the resort's private beach.",
    "evening": "Savor a fine dining experience under the stars with the Arabian Gulf as your backdrop.",
    "website": "https://www.fourseasons.com/dubai/",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/dubai1.png?v=1741070795",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png?v=1743128548",
                "product_link": "https://jbthejetsetter.com/products/day-4-boat-life-in-dubai",
    "location": "Dubai",
    "website": "https://www.burjkhalifa.ae/en/",
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      55.1798,
      25.1355
    ]
  }
},
                      {
      "type": "Feature",
      "properties": {
                "week_num": 1,
                "star": "5 star hotel",
                "season": "Winter 25'",
                "date": "2025-01-03",
                "category": "Resort Escapes",
    "sub-category": "Waterfront Retreats",
                "month": "January",
                "collection_name": "World Tour",
                "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/dubai_rating.png?v=1743130878",
                "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capetown2.png?v=1741398618",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png?v=1743128548",
                "product_link": "https://jbthejetsetter.com/products/week-1-cape-town-the-atlantic-jewel",
                "name": "One&Only Cape Town Hotel",
                "address": "Dock Rd, V&A Waterfront",
                "city": "Cape Town",
                "country": "South Africa",
                "experience_description": "A luxurious waterfront resort with stunning Table Mountain views, offering pet-friendly accommodations and personalized services for four-legged guests.",
                "caption": "Where elegance meets pet-friendly indulgence.",
                "source": "https://www.oneandonlyresorts.com/cape-town",
                "website": "https://www.oneandonlyresorts.com/cape-town"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [18.4233, -33.9072]
      }
    },
      
              {
            "type": "Feature",
            "properties": {
                "week_num": 3,
                "date": "2025-01-17",
                "season": "Winter 25'",
                "name": "Wish List",
                "rating": "",
                "address": "The Maldives",
                "city": "The Maldives",
                "country": "",
                "category": "",
    "sub-category": "Waterfront Retreats",
                "month": "February",
                "collection_name": "World Tour",
                "highlight": "Overwater Villa Escape",
                "experience_description": "Wake up in an overwater villa with endless turquoise views, snorkel with manta rays, and unwind with a spa session above the ocean.",
                "caption": "Overwater villa turquoise views",
                "morning": "Start your day with a luxury breakfast and a scenic morning walk in The Maldives.",
                "midday": "Main experience: Overwater villa escape.",
                "afternoon": "Explore local culture or unwind at Cheval Blanc Randheli.",
                "evening": "Enjoy a fine dining experience and exclusive nightlife in The Maldives.",
                "website": "https://www.chevalblanc.com/en/maison/maldives/",
                "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/maldives1.png?v=1741070815",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/collection_celebration_20.png?v=1741131953",
                "product_link": "https://jbthejetsetter.com/products/day-5-overwater-villa-escape-in-the-maldives",
                "location": "The Maldives"
             
                
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    73.2207,
                    3.2028
                ]
            }
        },

      {
  "type": "Feature",
  "properties": {
    "week_num": 2,
    "season": "Winter 25'",
    "date": "2025-02-29",
    "name": "1 Hotel San Francisco",
    "address": "8 Mission St, San Francisco, CA 94105, USA",
    "rating": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/sf1hotel.png?v=1743146697",
    "city": "San Francisco",
    "country": "United States",
    "category": "Boutique Stays",
    "sub-category": "Waterfront Retreats",
    "month": "February",
    "collection_name": "World Tour",
    "highlight": "Eco-Luxury Meets Urban Calm",
    "experience_description": "Enjoy the serenity of sustainable luxury at 1 Hotel San Francisco—where nature, wellness, and wagging tails are part of the check-in experience. Big dogs welcome, no weight limits!",
    "caption": "Urban zen with room to roam 🪴🐾",
    "morning": "Stroll the Embarcadero as the sun rises and enjoy a light, organic breakfast at Terrene’s patio.",
    "midday": "Relax in your eco-chic suite or visit the Ferry Building nearby for dog-friendly outdoor bites.",
    "afternoon": "Get cozy in your room’s reading nook while your pup naps on a comfy bed by your side.",
    "evening": "Watch the bay lights glimmer while sharing a locally sourced dinner outdoors.",
    "website": "https://www.1hotels.com/san-francisco",
    "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/sanfrancisco.png?v=1741412158",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png?v=1743128548",
        "product_link": "https://jbthejetsetter.com/products/golden-waves-in-the-bay", 
    "location": "San Francisco"
  },
  "geometry": {
    "type": "Point",
    "coordinates": [
      -122.3927,
      37.7930
    ]
  }
},

    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-10",
        "name": "Four Seasons Resort Bali at Jimbaran Bay",
        "address": "Jimbaran Bay, Bali, Indonesia",
        "rating": "https://cdn.example.com/fourseasons_bali_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_bali.png",
        "city": "Jimbaran",
        "country": "Indonesia",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Coastal Luxury & Pet‑Friendly Haven",
        "experience_description": "Enjoy serene beachfront luxury with stunning views and tailored pet‑friendly amenities at the Four Seasons Resort Bali at Jimbaran Bay.",
        "caption": "Exquisite beachfront retreat in Bali",
        "morning": "Begin with a sunrise beach walk and gourmet breakfast.",
        "midday": "Relax by the infinity pool overlooking the ocean.",
        "afternoon": "Unwind with spa treatments and dedicated pet‑pampering sessions.",
        "evening": "Dine al fresco under the stars with ocean vistas.",
        "website": "https://www.fourseasons.com/jimbaranbay/",
        "product_link": "https://jbthejetsetter.com/products/bali-jimbaran-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/bali_jimbaran.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Bali",
        "average_price": "IDR 7,000,000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [115.2167, -8.7933]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-11",
        "name": "The Ritz-Carlton, Laguna Niguel",
        "address": "Laguna Niguel, California, USA",
        "rating": "https://cdn.example.com/lagunaniguel_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_laguniguel.png",
        "city": "Laguna Niguel",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Elegant Coastal Luxury",
        "experience_description": "Experience refined luxury and sweeping ocean views at The Ritz-Carlton, Laguna Niguel—with dedicated pet‑friendly services to match.",
        "caption": "Coastal elegance in California",
        "morning": "Enjoy a lavish breakfast with ocean vistas.",
        "midday": "Relax at the beachfront pool with pet amenities.",
        "afternoon": "Stroll along the pristine beach with your pet.",
        "evening": "Savor fine dining with a sunset over the Pacific.",
        "website": "https://www.ritzcarlton.com/en/hotels/laguna-niguel",
        "product_link": "https://jbthejetsetter.com/products/laguna-niguel-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/laguna_niguel.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Laguna Niguel",
        "average_price": "$1100/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-117.693, 33.509]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-12",
        "name": "Montage Laguna Beach",
        "address": "Laguna Beach, California, USA",
        "rating": "https://cdn.example.com/montage_lb_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_montage_lb.png",
        "city": "Laguna Beach",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Artistic Coastal Retreat",
        "experience_description": "Discover an artful blend of luxury and laid‑back coastal living at Montage Laguna Beach, complete with bespoke pet‑friendly experiences.",
        "caption": "Chic coastal retreat in Laguna Beach",
        "morning": "Start with seaside yoga and a gourmet breakfast.",
        "midday": "Unwind by a stunning oceanfront pool.",
        "afternoon": "Explore local art galleries with your pet.",
        "evening": "Dine on fresh seafood with mesmerizing ocean views.",
        "website": "https://www.montagehotels.com/lagunabeach/",
        "product_link": "https://jbthejetsetter.com/products/laguna-beach-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/laguna_beach.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Laguna Beach",
        "average_price": "$1300/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-117.864, 33.529]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-13",
        "name": "Rosewood Mayakoba",
        "address": "Playa del Carmen, Quintana Roo, Mexico",
        "rating": "https://cdn.example.com/mayakoba_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_mayakoba.png",
        "city": "Playa del Carmen",
        "country": "Mexico",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Tropical Luxury on the Riviera Maya",
        "experience_description": "Indulge in opulent beachfront luxury with exclusive pet‑friendly amenities at Rosewood Mayakoba, a gem on the Riviera Maya.",
        "caption": "Tropical elegance and ocean views",
        "morning": "Enjoy a beachfront breakfast with tropical breezes.",
        "midday": "Relax in a private cabana by the lagoon.",
        "afternoon": "Experience world‑class spa treatments with pet care.",
        "evening": "Dine under palm trees with stunning ocean vistas.",
        "website": "https://www.rosewoodhotels.com/en/mayakoba",
        "product_link": "https://jbthejetsetter.com/products/mayakoba-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/mayakoba.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Playa del Carmen",
        "average_price": "€950/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-87.0000, 20.6700]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-14",
        "name": "One&Only Reethi Rah",
        "address": "North Malé Atoll, Maldives",
        "rating": "https://cdn.example.com/oneonly_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_oneonly.png",
        "city": "Reethi Rah",
        "country": "Maldives",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Exclusive Island Retreat with Pet Amenities",
        "experience_description": "Escape to paradise with unmatched luxury and bespoke pet‑friendly services at One&Only Reethi Rah in the Maldives.",
        "caption": "Island luxury redefined",
        "morning": "Start with a private beach breakfast and ocean view.",
        "midday": "Relax by a pristine infinity pool with pet care.",
        "afternoon": "Explore turquoise waters with your pet.",
        "evening": "Indulge in gourmet dining under the stars.",
        "website": "https://www.oneandonlyresorts.com/reethi-rah",
        "product_link": "https://jbthejetsetter.com/products/reethi-rah-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/reethi_rah.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Maldives",
        "average_price": "$1500/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [73.5000, 3.5000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-15",
        "name": "The Oberoi Udaivilas",
        "address": "Lake Pichola, Udaipur, India",
        "rating": "https://cdn.example.com/udaivilas_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_udaivilas.png",
        "city": "Udaipur",
        "country": "India",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Lakeside Royalty & Pet‑Friendly Charm",
        "experience_description": "Experience regal luxury on the banks of Lake Pichola at The Oberoi Udaivilas, offering opulent amenities and exceptional pet services.",
        "caption": "Regal lakeside luxury in Udaipur",
        "morning": "Enjoy a royal breakfast with lakeside views.",
        "midday": "Cruise on the lake or relax in lavish surroundings.",
        "afternoon": "Explore Udaipur's historic charms with your pet.",
        "evening": "Dine with views of the illuminated city and lake.",
        "website": "https://www.oberoihotels.com/hotels-in-udaipur/",
        "product_link": "https://jbthejetsetter.com/products/udaivilas-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/udaivilas.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Udaipur",
        "average_price": "₹70,000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [73.7000, 24.5850]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-16",
        "name": "Bvlgari Resort Bali",
        "address": "Uluwatu, Bali, Indonesia",
        "rating": "https://cdn.example.com/bvlgari_bali_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_bvlgari_bali.png",
        "city": "Uluwatu",
        "country": "Indonesia",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Italian Elegance on a Tropical Coast",
        "experience_description": "Savor the fusion of Italian style and Balinese charm at Bvlgari Resort Bali, with stunning ocean views and exclusive pet‑friendly services.",
        "caption": "Tropical Italian elegance",
        "morning": "Begin with a poolside breakfast and ocean breeze.",
        "midday": "Relax in a private villa with pet pampering.",
        "afternoon": "Enjoy seaside massages and water sports with your pet.",
        "evening": "Dine in exquisite Italian style under the stars.",
        "website": "https://www.bulgarihotels.com/en_US/bvlgari-resort-bali",
        "product_link": "https://jbthejetsetter.com/products/bvlgari-bali-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/bvlgari_bali.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Bali",
        "average_price": "IDR 8,000,000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [115.2167, -8.8600]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-17",
        "name": "InterContinental Fiji Resort & Spa",
        "address": "Denarau Island, Fiji",
        "rating": "https://cdn.example.com/fiji_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_fiji.png",
        "city": "Denarau",
        "country": "Fiji",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Tropical Island Luxury & Pet‑Friendly Service",
        "experience_description": "Experience tropical bliss at InterContinental Fiji Resort & Spa, where pristine beaches meet exceptional pet amenities.",
        "caption": "Island luxury in Fiji",
        "morning": "Savor a beachfront breakfast with stunning ocean views.",
        "midday": "Relax in a cabana by the turquoise lagoon.",
        "afternoon": "Enjoy water sports and pet‑friendly adventures.",
        "evening": "Dine on fresh seafood as the island sunset unfolds.",
        "website": "https://www.ihg.com/intercontinental/hotels/us/en/denarau",
        "product_link": "https://jbthejetsetter.com/products/fiji-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/fiji1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Fiji",
        "average_price": "FJD 600/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [177.4500, -17.7500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-18",
        "name": "The Datai Langkawi",
        "address": "Langkawi, Malaysia",
        "rating": "https://cdn.example.com/datai_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_datai.png",
        "city": "Langkawi",
        "country": "Malaysia",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Rainforest Retreat Meets Seaside Luxury",
        "experience_description": "Discover an enchanting blend of rainforest serenity and oceanfront luxury at The Datai Langkawi—with exceptional pet services.",
        "caption": "Exotic beachfront retreat in Langkawi",
        "morning": "Enjoy breakfast amidst tropical greenery and ocean views.",
        "midday": "Relax at a private beach cabana.",
        "afternoon": "Explore lush rainforest trails with your pet.",
        "evening": "Dine with a backdrop of sunset and sea.",
        "website": "https://www.thedatai.com/langkawi",
        "product_link": "https://jbthejetsetter.com/products/langkawi-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/langkawi1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Langkawi",
        "average_price": "MYR 1000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [99.6700, 6.3500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-19",
        "name": "Four Seasons Resort Seychelles",
        "address": "Mahé Island, Seychelles",
        "rating": "https://cdn.example.com/seychelles_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_seychelles.png",
        "city": "Mahé",
        "country": "Seychelles",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Exquisite Island Luxury & Pet‑Friendly Service",
        "experience_description": "Relax in paradisiacal luxury at Four Seasons Resort Seychelles, where idyllic beaches and top‑notch pet services create an unforgettable escape.",
        "caption": "Island paradise in Seychelles",
        "morning": "Begin with a refreshing beachfront breakfast.",
        "midday": "Lounge by the infinity pool overlooking the ocean.",
        "afternoon": "Stroll the white-sand beaches with your pet.",
        "evening": "Indulge in gourmet dining with ocean views.",
        "website": "https://www.fourseasons.com/seychelles/",
        "product_link": "https://jbthejetsetter.com/products/seychelles-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/seychelles1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Seychelles",
        "average_price": "$1800/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [55.4500, -4.6670]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-20",
        "name": "The Ritz-Carlton, Aruba",
        "address": "Palm Beach, Aruba",
        "rating": "https://cdn.example.com/aruba_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_aruba.png",
        "city": "Palm Beach",
        "country": "Aruba",
        "category": "Grand Hotel",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Caribbean Luxury & Pet‑Friendly Hospitality",
        "experience_description": "Revel in the vibrant beauty of the Caribbean with luxurious accommodations and exclusive pet amenities at The Ritz-Carlton, Aruba.",
        "caption": "Caribbean beachfront elegance",
        "morning": "Enjoy a tropical breakfast with ocean views.",
        "midday": "Relax by the beach with pet pampering.",
        "afternoon": "Explore Aruba's coastal charm with your pet.",
        "evening": "Dine in sumptuous style as the sunset paints the sky.",
        "website": "https://www.ritzcarlton.com/en/hotels/aruba",
        "product_link": "https://jbthejetsetter.com/products/aruba-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/aruba1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Aruba",
        "average_price": "$1000/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-70.0000, 12.5000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-21",
        "name": "Conrad Maldives Rangali Island",
        "address": "Rangali Island, Maldives",
        "rating": "https://cdn.example.com/rangali_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_rangali.png",
        "city": "Rangali Island",
        "country": "Maldives",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Underwater Dining & Secluded Island Luxury",
        "experience_description": "Experience the epitome of luxury with underwater dining and unmatched pet‑friendly services at Conrad Maldives Rangali Island.",
        "caption": "Exotic Maldives luxury",
        "morning": "Enjoy breakfast with oceanfront views.",
        "midday": "Relax in your overwater villa with pet amenities.",
        "afternoon": "Snorkel in crystal-clear waters with your pet.",
        "evening": "Dine underwater surrounded by marine life.",
        "website": "https://www.conradhotels.com/en/hotels/maldives/rangali-island",
        "product_link": "https://jbthejetsetter.com/products/maldives-rangali-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/rangali1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Maldives",
        "average_price": "$1700/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [73.5000, 3.5000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-22",
        "name": "Shangri-La's Mactan Resort and Spa",
        "address": "Mactan Island, Cebu, Philippines",
        "rating": "https://cdn.example.com/mactan_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_mactan.png",
        "city": "Mactan",
        "country": "Philippines",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Island Paradise & Pet‑Friendly Luxury",
        "experience_description": "Indulge in a tropical escape at Shangri-La's Mactan Resort and Spa, offering exquisite beachfront accommodations and dedicated pet services.",
        "caption": "Tropical luxury in Cebu",
        "morning": "Savor a seaside breakfast with island views.",
        "midday": "Relax by the infinity pool with pet-friendly service.",
        "afternoon": "Enjoy water activities with your furry friend.",
        "evening": "Dine under the stars on the beach.",
        "website": "https://www.shangri-la.com/cebu/mactanresort/",
        "product_link": "https://jbthejetsetter.com/products/mactan-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/mactan1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Cebu",
        "average_price": "₱8500/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [123.9440, 10.3157]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-23",
        "name": "InterContinental Dubai Festival City",
        "address": "Dubai, United Arab Emirates",
        "rating": "https://cdn.example.com/dubai_festival_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_dubai_festival.png",
        "city": "Dubai",
        "country": "United Arab Emirates",
        "category": "Grand Hotel",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Modern Waterfront Luxury in Dubai",
        "experience_description": "Enjoy contemporary luxury with waterfront views and exclusive pet‑friendly amenities at InterContinental Dubai Festival City.",
        "caption": "Modern waterfront luxury in Dubai",
        "morning": "Start with a sumptuous breakfast overlooking Dubai Creek.",
        "midday": "Relax by the pool with pet pampering services.",
        "afternoon": "Explore Dubai’s vibrant waterfront attractions.",
        "evening": "Dine in style with mesmerizing city views.",
        "website": "https://www.intercontinental.com/dubaifestivalcity",
        "product_link": "https://jbthejetsetter.com/products/dubai-festival-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/dubai_festival1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Dubai",
        "average_price": "$900/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [55.3880, 25.2520]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-24",
        "name": "Mandarin Oriental, Miami",
        "address": "Brickell Key, Miami, USA",
        "rating": "https://cdn.example.com/miami_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_miami.png",
        "city": "Miami",
        "country": "USA",
        "category": "Grand Hotel",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Contemporary Coastal Luxury in Miami",
        "experience_description": "Experience unrivaled waterfront luxury and bespoke pet services at Mandarin Oriental, Miami—set on a private island in the heart of the city.",
        "caption": "Coastal luxury in Miami",
        "morning": "Gourmet breakfast with sweeping water views.",
        "midday": "Unwind at a lavish poolside cabana with pet amenities.",
        "afternoon": "Explore the vibrant Brickell district with your pet.",
        "evening": "Savor exquisite dining with a waterfront backdrop.",
        "website": "https://www.mandarinoriental.com/miami",
        "product_link": "https://jbthejetsetter.com/products/miami-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/miami1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Miami",
        "average_price": "$1300/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-80.1820, 25.7826]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-25",
        "name": "Waldorf Astoria Los Cabos Pedregal",
        "address": "Pedregal, Cabo San Lucas, Mexico",
        "rating": "https://cdn.example.com/loscabos_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_loscabos.png",
        "city": "Cabo San Lucas",
        "country": "Mexico",
        "category": "Grand Hotel",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Spectacular Oceanfront Luxury in Cabo",
        "experience_description": "Indulge in panoramic ocean views and exceptional pet services at Waldorf Astoria Los Cabos Pedregal.",
        "caption": "Oceanfront luxury in Cabo San Lucas",
        "morning": "Savor a seaside breakfast with breathtaking views.",
        "midday": "Relax at a cliffside infinity pool with pet care.",
        "afternoon": "Explore Cabo’s vibrant coastal scene with your pet.",
        "evening": "Dine in an elegant setting with ocean vistas.",
        "website": "https://www.waldorfastorialoscabos.com/",
        "product_link": "https://jbthejetsetter.com/products/los-cabos-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/loscabos1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Cabo San Lucas",
        "average_price": "$1400/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-109.5000, 23.0833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-26",
        "name": "Belmond Maroma Resort & Spa",
        "address": "Riviera Maya, Mexico",
        "rating": "https://cdn.example.com/maroma_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_maroma.png",
        "city": "Riviera Maya",
        "country": "Mexico",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Boutique Beachfront Luxury in the Riviera Maya",
        "experience_description": "Experience unparalleled elegance and pet‑friendly service at Belmond Maroma Resort & Spa, set along the turquoise waters of the Riviera Maya.",
        "caption": "Boutique beachfront luxury",
        "morning": "Enjoy a tropical breakfast on the beach.",
        "midday": "Relax in a secluded cabana with pet amenities.",
        "afternoon": "Explore nearby cenotes and local culture with your pet.",
        "evening": "Dine in an intimate, ambient setting by the sea.",
        "website": "https://www.belmond.com/hotels/central-america/mexico/belmond-maroma-resort-and-spa/",
        "product_link": "https://jbthejetsetter.com/products/maroma-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/maroma1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Riviera Maya",
        "average_price": "$1200/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-87.0000, 20.8000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-27",
        "name": "Amanyara",
        "address": "Turks & Caicos",
        "rating": "https://cdn.example.com/amanyara_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_amanyara.png",
        "city": "Turks & Caicos",
        "country": "Turks & Caicos",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Secluded Island Paradise with Pet Perks",
        "experience_description": "Experience ultimate privacy and exquisite luxury at Amanyara in Turks & Caicos, complete with exceptional pet‑friendly services.",
        "caption": "Exclusive island retreat",
        "morning": "Start with a private breakfast on a secluded beach.",
        "midday": "Relax in an overwater villa with pet pampering.",
        "afternoon": "Explore crystal-clear waters and marine life with your pet.",
        "evening": "Dine under the stars with breathtaking ocean views.",
        "website": "https://www.aman.com/resorts/amanyara",
        "product_link": "https://jbthejetsetter.com/products/turks-and-caicos-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/amanyara1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Turks & Caicos",
        "average_price": "$2500/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-72.2520, 21.8000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-28",
        "name": "The St. Regis Bahia Beach Resort",
        "address": "Guaynabo, Puerto Rico",
        "rating": "https://cdn.example.com/bahia_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_bahia.png",
        "city": "Guaynabo",
        "country": "Puerto Rico",
        "category": "Resort Escapes",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Luxury Beachfront Escape in the Caribbean",
        "experience_description": "Relish sophisticated elegance and outstanding pet services at The St. Regis Bahia Beach Resort, set on a pristine Caribbean beach.",
        "caption": "Caribbean luxury at its finest",
        "morning": "Begin with a beachside breakfast.",
        "midday": "Relax by the infinity pool with pet care.",
        "afternoon": "Explore local culture and beachfront scenery with your pet.",
        "evening": "Savor gourmet dining with a view of the Caribbean sunset.",
        "website": "https://www.marriott.com/hotels/travel/sjrbw-the-st-regis-bahia-beach-resort/",
        "product_link": "https://jbthejetsetter.com/products/bahia-beach-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/bahia1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Puerto Rico",
        "average_price": "$1600/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-66.2000, 18.4500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-29",
        "name": "Hamilton Princess & Beach Club",
        "address": "Hamilton, Bermuda",
        "rating": "https://cdn.example.com/bermuda_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_bermuda.png",
        "city": "Hamilton",
        "country": "Bermuda",
        "category": "Boutique Stay",
        "sub-category": "Waterfront Retreats",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Bermuda's Iconic Waterfront Elegance",
        "experience_description": "Immerse yourself in timeless luxury and stunning ocean views at Hamilton Princess & Beach Club, a pet‑friendly haven in Bermuda.",
        "caption": "Iconic Bermuda luxury",
        "morning": "Enjoy a lavish breakfast with panoramic harbor views.",
        "midday": "Relax at an exclusive beach club with pet services.",
        "afternoon": "Stroll the historic streets of Hamilton with your pet.",
        "evening": "Experience elegant dining with a seaside ambiance.",
        "website": "https://www.hamiltonprincess.com/",
        "product_link": "https://jbthejetsetter.com/products/bermuda-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/bermuda1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "Bermuda",
        "average_price": "$1800/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-64.7800, 32.3100]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "week_num": 3,
        "season": "Spring 25'",
        "date": "2025-03-30",
        "name": "The Chatwal, New York",
        "address": "New York, USA",
        "rating": "https://cdn.example.com/chatwal_rating.png",
        "jb_rating": "https://cdn.example.com/jb_rating_chatwal.png",
        "city": "New York",
        "country": "USA",
        "category": "Boutique Stay",
        "sub-category": "Elevated Escapes",
        "month": "March",
        "collection_name": "World Tour",
        "highlight": "Boutique Luxury & Tail‑Wagging Charm",
        "experience_description": "Experience intimate, artful luxury and warm pet‑friendly service at The Chatwal in New York.",
        "caption": "Boutique charm with pet perks",
        "morning": "Creative breakfast in a stylish setting.",
        "midday": "Discover curated art exhibits.",
        "afternoon": "Stroll through Manhattan’s hidden treasures with your pet.",
        "evening": "Savor an intimate dinner in elegant ambiance.",
        "website": "https://www.thechatwalny.com/",
        "product_link": "https://jbthejetsetter.com/products/chatwal-dog-friendly",
        "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/chatwal1.png",
        "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/paw3.png",
        "location": "New York",
        "average_price": "$1700/night"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [-73.9880, 40.7527]
      }
    },

    ]
}
